import { FC, ReactNode } from "react"
import { FaCode } from "react-icons/fa"

type TagProps = {
  text: string
  icon?: ReactNode
}
export const TagIcon: FC<TagProps> = ({ icon, text }) => {
  return (
    <div className="flex items-center gap-2">
      {icon ? icon : <FaCode aria-hidden="true" />}
      {text}
    </div>
  )
}
